enum SessionType {
    RESTAURANT = "RESTAURANT",
    FROM_HOME = "FROM_HOME",
}

export default SessionType